import { IDemoAttributionParams } from '@webtrader/core/api/user/demoAccount';

import { IDeepLinkData } from './types';

interface IAppsFlyerDeepLinkParams {
  pid?: string; // Publisher ID / Media Source
  c?: string; // Campaign ID
  af_ad?: string; // Ad ID
  af_xp?: string; // Custom parameter
  deep_link_value?: string; // Deep link value
}

export const parseDeepLinkUrl = (url: string): IAppsFlyerDeepLinkParams => {
  try {
    const urlObj = new URL(url);
    const params: IAppsFlyerDeepLinkParams = {};

    // Extract parameters from URL
    urlObj.searchParams.forEach((value, key) => {
      switch (key) {
        case 'pid':
          params.pid = value;
          break;
        case 'c':
          params.c = value;
          break;
        case 'af_ad':
          params.af_ad = value;
          break;
        case 'af_xp':
          params.af_xp = value;
          break;
        case 'deep_link_value':
          params.deep_link_value = value;
          break;
      }
    });

    return params;
  } catch (error) {
    console.error('APPSFLYER - Error parsing deep link URL:', error);
    return {};
  }
};

export interface IAttributionFields {
  appsFlyerAttribute?: IDemoAttributionParams;
}

export const buildAttributionFields = (attribution?: IDeepLinkData | null): IAttributionFields => {
  // af_sub[n] (n=1-5): Custom subscriber parameters for additional tracking data.
  // Ref: https://support.appsflyer.com/hc/en-us/articles/207447163-About-link-structure-and-parameters#af_sub
  const appsFlyerAttribute: IDemoAttributionParams | undefined = attribution?.mediaSource
    ? {
        pId: attribution.mediaSource,
        afSub:
          [attribution.afSub, attribution.afSub2, attribution.afSub3, attribution.afSub4, attribution.afSub5]
            .filter(Boolean)
            .join(',') || undefined,
        afKeyword: attribution.afKeyword,
        afAdFormat: attribution.afAdFormat,
        clickId: attribution.clickid
      }
    : undefined;

  return { appsFlyerAttribute };
};
